import * as React from 'react';
import styles from './chip-input.module.scss';
import { WChip } from '../../wrappers/wrapper';
import { FC, useRef, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';

interface ChipInputProps {
  limit?: number;
  error?: boolean;
  helperText?: string;
  placehodler: string;
  chips: any[];
  props?: React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
    icon?: string;
  };
  options?: string[];
  type?: 'input' | 'autocomplete';
  addItem: (value: string) => void;
  deleteItem: (value: string) => void;
  optionsClass?: string;
}
const ChipInput: FC<ChipInputProps> = ({
  limit = 10,
  error,
  helperText,
  placehodler,
  chips,
  props,
  type = 'input',
  options = [],
  addItem,
  deleteItem,
  optionsClass,
}) => {
  const ref: any = useRef();
  const [value, setValue] = useState<string>('');

  const handleKeyDown = (ev: any) => {
    if (!value?.trim() || chips.includes(value)) return;
    if (ev.keyCode === 13 || ev.keyCode === 188) {
      addItem(value);
      setValue('');
    }
  };

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setValue(e.target.value);
  };

  const inputType = {
    input: (
      <input
        {...props}
        className={styles['input']}
        placeholder={placehodler}
        value={value}
        onChange={(e) => {
          e.target.value !== ',' && setValue(e.target.value);
        }}
        onKeyDown={handleKeyDown}
      />
    ),
    autocomplete: (
      <Autocomplete
        disablePortal
        clearIcon={null}
        popupIcon={null}
        options={options}
        inputValue={value}
        sx={{
          minWidth: '200px',
          '& .MuiOutlinedInput-root': {
            padding: 0,
            paddingRight: '0 !important',
            '& fieldset': {
              border: 'none',
            },
            '.MuiAutocomplete-input': {
              padding: 0,
            },
          },
        }}
        renderInput={(params) => (
          <TextField onChange={handleTextChange} {...params} placeholder={placehodler} />
        )}
        onChange={(event: any, newValue: string | null) => {
          if (!newValue) return;
          addItem(newValue!);
          setValue('');
        }}
        ListboxProps={{
          className: optionsClass,
        }}
      />
    ),
  };

  return (
    <div className={styles['container']}>
      <div ref={ref} className={`${styles['chips-wrapper']} ${error && styles['error']}`}>
        {chips.map((el, index) => (
          <WChip
            key={`chip-${index}`}
            label={el}
            variant="outlined"
            onDelete={() => deleteItem(el)}
          />
        ))}
        {chips.length < limit ? inputType[type] : null}
      </div>
      {error && helperText ? <span className={styles['error-message']}>{helperText}</span> : ''}
    </div>
  );
};

export default ChipInput;
